/**
 * @file index.js
 * @author sunxiaofeng01
 * @desc 法律百家号外链链接
 */
export default {
    // 百家号文章
    bjhContent: 'https://baijiahao.baidu.com/builder/rc/content?from=lvlin',
    // 百家号发文
    bjhEdit: 'https://baijiahao.baidu.com/builder/rc/edit?type=news&from=lvlin',
    // 百家号设置
    bjhSetting: 'https://baijiahao.baidu.com/builder/rc/settings/accountSet',
    // 百家号后台
    bjhAccount: 'https://baijiahao.baidu.com/builder/rc/settings/accountSet?app_id=1763592829212560',
    // 百家号咨询设置
    bjhToolBar: 'http://mbd.baidu.com/gompage/accounttoolbar',
    // 百家号注册反馈规范
    bjhRegisterFeedback: 'https://baijiahao.baidu.com/builder/rc/stores/complain?aside=0&freezeModal=0&fixedBottom=0&from=lvlin',
    // 百家号注册错误跳转
    bjhError: 'https://baijiahao.baidu.com/builder/rc/stores/complain?aside=0&freezeModal=0&fixedBottom=0&from=lvlin',
    // 百家号服务协议
    bjhAgreement: 'https://baijiahao.baidu.com/docs/#/markdownsingle/BaiJiaHaoFuWuXieYi',
    // 百家号注册规范
    bjhRegisterRule: 'https://baijiahao.baidu.com/docs/#/markdownsingle/BaiJiaHaoShiYongShouCeWanZhengBan/%E5%B8%90%E5%8F%B7%E5%87%86%E5%85%A5',
    // 百家号常见问题
    bjhQA: 'https://baijiahao.baidu.com/docs/#/normalcomplex/question/accountProblem1'
};
